import type { RentLedgerFilters } from '../types/rentLedgerTypes'

export const rentLedgerKeys = {
  all: ['rentLedger'] as const,

  lists: () => [...rentLedgerKeys.all, 'list'] as const,
  list: (filters: RentLedgerFilters) => [...rentLedgerKeys.lists(), filters] as const,

  details: () => [...rentLedgerKeys.all, 'detail'] as const,
  /**
   * Keyed by PROPERTY, not by a ledger id — the ledger is a view of a property,
   * and its bills and movements hang off this key so paying a bill refreshes
   * the pots that paying it changed.
   */
  detail: (propertyId: string) => [...rentLedgerKeys.details(), propertyId] as const,

  /** Same "depends on who's asking" reasoning as the distribution-run permission keys. */
  billPaymentPermission: (billId: string) =>
    [...rentLedgerKeys.all, 'billPaymentPermission', billId] as const,
}
